import { useIsNavigatingBack } from '../context/FlowContainerContext.tsx';

type ValidationMessageProps = {
  message?: string;
};

/**
 * Renders a field validation error message
 */
function FieldValidationMessage(props: ValidationMessageProps) {
  const isNavigatingBack = useIsNavigatingBack();

  if (isNavigatingBack || !props.message) {
    return null;
  }

  return <p className="mt-2 text-form-message-error text-sm font-medium leading-5 px-1">{props.message}</p>;
}

export default FieldValidationMessage;
